module.exports = "/images/Mechanical---Hero.jpg";